import { render, staticRenderFns } from "./CashDocByReceiptsHead.vue?vue&type=template&id=23e7cf98&scoped=true&"
import script from "./CashDocByReceiptsHead.vue?vue&type=script&lang=ts&"
export * from "./CashDocByReceiptsHead.vue?vue&type=script&lang=ts&"
import style0 from "./CashDocByReceiptsHead.vue?vue&type=style&index=0&id=23e7cf98&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23e7cf98",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VExpandXTransition } from 'vuetify/lib/components/transitions';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VCol,VDivider,VExpandXTransition,VRow,VSpacer,VSwitch})
